import type { ReactNode } from 'react';
import { ResourceBar } from '@sorrem-client/ui/components';
import classnames from 'classnames';
import styles from './TargetEssenceBar.module.scss';

interface TargetEssenceBarProps {
    /** The target's name, shown in the bar's label frame. */
    name: string;
    value: number;
    maxValue: number;
    /** The target's color: tints the bar's fill and gems. */
    color: string;
    /** Shown under the bar, e.g. what it takes to damage the target. */
    message?: ReactNode;
    /** Classes for the root, e.g. to set `--resource-bar-width` / `--resource-bar-height`. */
    className?: string;
}

/**
 * The essence of the run's main target, such as a boss or the Crucible's
 * heart: the bar with the target's name, and an optional message under it.
 * The caller sizes the bar by setting `--resource-bar-width` and
 * `--resource-bar-height` through `className`.
 */
export function TargetEssenceBar({ name, value, maxValue, color, message, className }: TargetEssenceBarProps): JSX.Element {
    return (
        <div className={classnames(styles.targetEssenceBar, className)}>
            <ResourceBar className={styles.bar} value={value} maxValue={maxValue} color={color} label={name} />
            {message !== undefined && <div className={styles.message}>{message}</div>}
        </div>
    );
}
